export default __webpack_public_path__ + "static/media/Couples Gratitude Journal.bb28542c.pdf";